import { NotificationsListResponseSchema } from '@disparos/contracts';
import { z } from 'zod';
import { apiFetch } from './client';

const VoidSchema = z.void();
const ReadAllResponseSchema = z.object({ updated: z.number().int().nonnegative() });

export async function listNotifications(
  options: { unreadOnly?: boolean; limit?: number } = {},
  signal?: AbortSignal,
) {
  const params: Record<string, string | number | boolean> = {};
  if (options.unreadOnly !== undefined) params.unreadOnly = options.unreadOnly;
  if (options.limit !== undefined) params.limit = options.limit;
  return apiFetch('/notifications', NotificationsListResponseSchema, {
    params,
    ...(signal !== undefined ? { signal } : {}),
  });
}

export async function markNotificationAsRead(id: string) {
  return apiFetch(`/notifications/${id}/read`, VoidSchema, { method: 'POST' });
}

export async function markAllNotificationsAsRead() {
  return apiFetch('/notifications/read-all', ReadAllResponseSchema, { method: 'POST' });
}
